import store from "../store";
import coreAPI from "../api/coreAPI";

/**
 *
 * Additional reading:
 * https://stackoverflow.com/a/50855093/8010396
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/error_event
 */
export async function initErrorLogging() {
  addEventListener("error", async (errorEvent) => {
    /* Extract error data and format for logging */
    const error = {
      message: errorEvent.message ? errorEvent.message : "",
      fileName: errorEvent.filename ? errorEvent.filename : "", // Notice case sensitive
      lineNumber: errorEvent.lineno ? errorEvent.lineno : "",
      columnNumber: errorEvent.colno ? errorEvent.colno : "",
      name: errorEvent.error && errorEvent.error.name ? errorEvent.error.name : "",
      stack: errorEvent.error && errorEvent.error.stack ? errorEvent.error.stack : "",
      cause: errorEvent.error && errorEvent.error.cause ? errorEvent.error.cause : "",
    };
    await constructAndLogError(error);
  });
}

export async function constructAndLogError(errorEvent) {
  if (!errorEvent) return;

  /* Prepare error data to send to server */
  const error = {
    /* Prepare additional useful information */
    extraInfo: {
      isClient: true,
      location: window.location.href,
      UID: store && store.state && store.state.auth && store.state.auth.user && store.state.auth.user._id ? store.state.auth.user._id : "",
    },
  };

  if (errorEvent.message) error.message = errorEvent.message;
  if (errorEvent.name) error.name = errorEvent.name;
  if (errorEvent.stack) error.stack = errorEvent.stack;
  if (errorEvent.fileName) error.fileName = errorEvent.fileName;
  if (errorEvent.lineNumber) error.lineNumber = errorEvent.lineNumber;
  if (errorEvent.columnNumber) error.columnNumber = errorEvent.columnNumber;
  if (errorEvent.cause) error.cause = errorEvent.cause;

  /* Prepare and send error to the server */
  const response = await coreAPI.logOneError(error);
  if (!response || !response.success) console.log("Logging error failed.");
}
